import React, { useState, useEffect } from 'react';
import { STATUS_CATEGORY_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { CellWrapper } from '../../../common/cell-wrapper/index.tsx';
import type { TransformedStatusCategoryField } from '../../../common/field-types/status-category/types.tsx';
import type { BasicListViewItem, FieldCellProps } from '../../../common/types.tsx';
import { StatusCategoryRead } from './read/index.tsx';

export const StatusCategory = ({
	cellData: field,
}: FieldCellProps<BasicListViewItem, TransformedStatusCategoryField>) => {
	const [statusCategory, setStatusCategory] = useState(field?.value || null);

	useEffect(() => {
		setStatusCategory(field?.value || null);
	}, [field?.value]);

	if (field == null) {
		return null;
	}

	return (
		<CellWrapper isEditable={false}>
			{statusCategory && <StatusCategoryRead {...statusCategory} />}
		</CellWrapper>
	);
};

export const statusCategoryCellHandler = {
	[STATUS_CATEGORY_TYPE]: StatusCategory,
};
